import { getConfigClient } from '../../../client/clientConfig';
import { getConfigBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk } from '../../../utils/api';
import { getCountriesQuery, getCurrenciesQuery, getTimezoneQuery } from './myOrgInfoQueries';
import {
  startLoading,
  stopLoading,
  updateCountries,
  updateCurrencies,
  updateTimeZones,
} from './myOrgInfoSlice';

export const getOrgInfoThunk = createApiThunk('GET_ORG_INFO', apiCall);
export const editOrgInfoThunk = createApiThunk('EDIT_ORG_INFO', apiCall);

export const getOrgInfo = () => (dispatch: AppDispatch) => {
  dispatch(
    getOrgInfoThunk({
      url: `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/`,
      method: 'GET',
    }),
  );
};

export const editOrgInfo = (data: any) => (dispatch: AppDispatch) => {
  return dispatch(
    editOrgInfoThunk({
      url: `${getConfigBaseUrl()}/v2/config/tenants/${data.tenantId}`,
      method: 'PUT',
      data,
    }),
  );
};

export const getCountries = () => (dispatch: AppDispatch) => {
  dispatch(startLoading());
  getConfigClient()
    .query({
      query: getCountriesQuery,
      fetchPolicy: 'network-only',
    })
    .then((response) => {
      dispatch(updateCountries(response));
    });
  dispatch(stopLoading());
};

export const getCurrencies = () => (dispatch: AppDispatch) => {
  dispatch(startLoading());
  getConfigClient()
    .query({
      query: getCurrenciesQuery,
      fetchPolicy: 'network-only',
    })
    .then((response) => {
      dispatch(updateCurrencies(response));
    });
  dispatch(stopLoading());
};

export const getTimezones = () => {
  return function (dispatch: AppDispatch) {
    dispatch(startLoading());
    getConfigClient()
      .query({
        query: getTimezoneQuery,
        fetchPolicy: 'network-only',
      })
      .then((response) => {
        dispatch(updateTimeZones(response));
      });
    dispatch(stopLoading());
  };
};
